export default "__VITE_ASSET__iL$oBN9K__"